import { useMutation } from '@apollo/client';
import { Campaign } from '../../shared/types';
import { CITRIN_CREATE_CAMPAIGN, CreateCampaignRequest, CreateCampaignResponse } from '..';

type CreateMutationFunction = (request: Campaign) => Promise<Campaign>;
export const useCreateCampaignMutation = (): { mutation: CreateMutationFunction; loading: boolean } => {
    const [mutation, { loading }] = useMutation<CreateCampaignResponse, CreateCampaignRequest>(CITRIN_CREATE_CAMPAIGN);
    const promiseMutation = async (request) => {
        const result = await mutation({
            variables: { request },
        });
        return result.data.CITRIN_MGT_createCampaign;
    };

    return {
        mutation: promiseMutation,
        loading,
    };
};
